import { render, staticRenderFns } from "./ExpenseSplittingModal.vue?vue&type=template&id=3b4c684e&"
import script from "./ExpenseSplittingModal.vue?vue&type=script&lang=js&"
export * from "./ExpenseSplittingModal.vue?vue&type=script&lang=js&"
import style0 from "./ExpenseSplittingModal.vue?vue&type=style&index=0&id=3b4c684e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports